module.exports = __webpack_public_path__ + "img/banner_bg.869d19b9.png";